// extracted by mini-css-extract-plugin
export default {"salary-advice-tooltip":"qhkzyqn___salary-advice-tooltip","salaryAdviceTooltip":"qhkzyqn___salary-advice-tooltip"};